export interface Genre {
    name: string;
    description: string;
}

export interface Genres { [key: string]: Genre; }

export default {
    action: {
        name: 'Action',
        description: 'Games that rely on speed and precision',
    },
    board: {
        name: 'Board',
        description: 'Games based on tabletop games, such as chess or cards.',
    },
    puzzle: {
        name: 'Puzzle',
        description: 'Games whose goal is to solve a set of puzzles',
    },
    racing: {
        name: 'Racing',
        description: 'Games whose main pourpose is to drive a vehicle towards a goal',
    },
    rpg: {
        name: 'RPG',
        description: 'Games in which players assume the roles of characters in a fictional setting',
    },
    simulation: {
        name: 'Simulation',
        description: 'Games that simulates a real world activities',
    },
    sports: {
        name: 'Sports',
        description: 'Sports games, such as football or golf',
    },
    strategy: {
        name: 'Strategy',
        description: 'Games based on decision making skills',
    },
    demo: {
        name: 'Demo',
        description: 'Software whose goal is to demonstrate clever use of the hardware',
    },
    software: {
        name: 'Software',
        description: 'Software that is not a game or a demo, such as an operating system or an editor',
    },
} as Genres;
